import { languageField } from './form-fields';

export const updateLanguageOptions = (languages: FormDropDownOption[], existingOptions: string[]) => {
  languageField.value.data.options = languages.filter(
    (option) => !existingOptions.includes(String(option.value)),
  );
};
